import styled from "styled-components"
import {
  desktopTextStyles,
  tabletTextStyles,
  mobileTextStyles,
} from "../shared/typography.styles"
import Breakpoints from "../shared/breakpoints"
import { FadeInBottom } from "../shared/keyframes.style"

export const Container = styled.div`
  grid-column: 1 / -1;
  grid-gap: 24px;

  @media (min-width: ${Breakpoints.md}) {
    grid-template-columns: 1fr 1fr;
    padding: 0 24px;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 3 / -3;
  }

  display: grid;

  margin-top: 64px;

  animation: ${props => !props.disableAnimations && FadeInBottom};
  animation-duration: 1.5s;
  animation-timing-function: ease;
  animation-delay: 0.8s;
  animation-fill-mode: both;
  animation-play-state: ${props => (props.isVisible ? "running" : "paused")};
`

export const CardWrapper = styled.div`
  padding: 22px;
  box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.05);
  @media (min-width: ${Breakpoints.lg}){
    padding: 32px;
  }
  & > div {
    display: flex;
    align-items: center;
  }

  & h3 {
    /* H4 Desk */
    flex-grow: 1;
    ${mobileTextStyles.MobileHeadingThreeBold}
    
    @media (min-width: ${Breakpoints.md}){
      ${desktopTextStyles.HeadingFiveRegular}
    }
    

    color: var(--slate);
    margin-left: 20px;
  }

  & > p {
    ${mobileTextStyles.MobileBodyRegular}
    color: var(--body-text-grey);
    margin-top: 20px;
    @media (min-width: ${Breakpoints.md}) {
      ${tabletTextStyles.TabletBodyRegular}
    }
    @media (min-width: ${Breakpoints.lg}) {
      ${desktopTextStyles.BodyText16}
    }
  }
`
